<template>
  <div class="component-wrap">
    <el-tabs
      :tab-position="tabPosition"
      style="max-height: 500px"
      type="border-card"
    >
      <el-tab-pane label="全部">
        <el-tag
          v-for="role in rolesOptions"
          class="role-tag"
          :type="isCheck(role) ? 'success' : 'info'"
          :checked="isCheck(role)"
          :key="`role${role.id}`"
          @click="onRoleCheck(role)"
          ><i class="el-icon-success"></i>&nbsp;{{ role.name }}
        </el-tag>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { GetUsersRoles } from "../api";
export default {
  props: {
    value: {
      type: Array,
      default: () => {
        return [];
      },
    },
    tabPosition: {
      type: String,
      default: "left",
    },
  },
  data() {
    return {
      rolesOptions: [],
      allRoles: [],
      selectRoles: [],
    };
  },
  created() {
    this.getRoles();
  },
  watch: {
    value: {
      handler() {
        this.upDateValue();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    upDateValue() {
      if (this.allRoles.length > 0 && this.value.length > 0) {
        this.selectRoles = [];
        this.allRoles.forEach((item) => {
          if (this.value.includes(item.id)) {
            this.selectRoles.push(item);
          }
        });
      } else {
        this.selectRoles = [];
      }
    },
    isCheck(role) {
      return this.selectRoles.some((target) => target.id === role.id);
    },
    getRoles() {
      GetUsersRoles().then((res) => {
        this.allRoles = res.data;
        this.rolesOptions = res.data;
        console.log("权限数据", res.data);
        this.upDateValue();
      });
    },

    onRoleCheck(role) {
      if (this.selectRoles.some((target) => target.id === role.id)) {
        this.selectRoles = this.selectRoles.filter(
          (target) => target.id !== role.id
        );
      } else {
        this.selectRoles.push(role);
      }
      let ids = this.selectRoles.map((item) => item.id);
      this.$emit("input", ids);
      this.$emit("change", ids, this.selectRoles);
    },
  },
};
</script>

<style lang="scss" scoped>
.component-wrap {
  box-sizing: border-box;
  padding: 15px;
  ::v-deep {
    .el-tabs__content {
      box-sizing: border-box;
      max-height: 500px;
      overflow-y: auto;
    }
  }
  .role-tag {
    margin-right: 20px;
    margin-bottom: 15px;
    cursor: pointer;
  }
}
</style>
